import { getAuthenticatedAxios, withErrorHandler } from './AuthenticatedAxiosProvider';
import { buildRequestUrl } from '../Config';

export const GetUserDetails = async () => {
  const url = buildRequestUrl('/api/users/user/get');
  const {data} = await withErrorHandler(() => getAuthenticatedAxios().get(url));

  return data;
};
